import { CardContent } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useQueryClient } from 'react-query';

import { Spacer } from 'theSource/components';
import { OverlineWithSubtext } from '../OverlineWithSubtext';
import {
  NarrowBoxStyled,
  WiderBoxStyled,
  InlineBoxStyled,
  CurrencyLabelStyled,
  PaymentAndCoverageStyled,
  CenterAlignedLabelStyled,
  CenterAlignedFontLabelStyled,
  CardContentStyled,
} from './PaymentAndCoverageStyled';
import {
  ContentSettingsResponseDto,
  GET_CONTENT_SETTINGS_QUERY_KEY,
} from 'theSource/queries';

export interface PaymentAndCoverageProps {
  perPayPeriodValue: number;
  coverageFromTo: string;
  hideEmptyCost?: boolean;
}

export const PaymentAndCoverage = ({
  perPayPeriodValue,
  coverageFromTo,
  hideEmptyCost = false,
}: PaymentAndCoverageProps) => {
  const queryClient = useQueryClient();
  const { t } = useTranslation('pages.benefits');

  const contentSettings: ContentSettingsResponseDto | undefined =
    queryClient.getQueryData(GET_CONTENT_SETTINGS_QUERY_KEY);

  return (
    <PaymentAndCoverageStyled data-testid="payment-and-coverage">
      <NarrowBoxStyled>
        {(!hideEmptyCost || perPayPeriodValue > 0) && (
          <CardContent>
            <InlineBoxStyled>
              <CurrencyLabelStyled component="div" variant="h5">
                $
              </CurrencyLabelStyled>
              <CenterAlignedFontLabelStyled component="div" variant="h5">
                {perPayPeriodValue}
              </CenterAlignedFontLabelStyled>
            </InlineBoxStyled>
            <CenterAlignedLabelStyled component="div" variant="body2">
              {contentSettings?.cost_period_text || t('perPayPeriod')}
            </CenterAlignedLabelStyled>
          </CardContent>
        )}
      </NarrowBoxStyled>
      <WiderBoxStyled>
        <CardContentStyled>
          <Spacer height={2} />
          <OverlineWithSubtext
            title={t('coveragePeriod')}
            subtext={coverageFromTo}
          />
        </CardContentStyled>
      </WiderBoxStyled>
    </PaymentAndCoverageStyled>
  );
};
